<ng-icon
  name='saxInfoCircleOutline'
  size='17px'
  [matTooltip]='matTooltipInfo'
  [matTooltipPosition]='matTooltipPositionInfo'
/>
